import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
  isOpen: boolean;
  forceCollapsed: boolean;
  previousState: boolean | null;
}

const initialState: SidebarState = {
  isOpen: true,
  forceCollapsed: false,
  previousState: null,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        // 閉じる前に現在の状態を保存
        if (state.previousState === null) {
          state.previousState = state.isOpen;
        }
        state.forceCollapsed = true;
        state.isOpen = false;
      } else {
        // 元の状態に戻す
        state.forceCollapsed = false;
        if (state.previousState !== null) {
          state.isOpen = state.previousState;
          state.previousState = null;
        }
      }
    },
  },
});

export const { setSidebarOpen, setSidebarCollapsed } = sidebarSlice.actions;
export default sidebarSlice.reducer;

